import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useAccount } from '@/lib/account';

export const STORAGE_KEY = 'manucreator-designer-v2';
// Forget the design on this device and the article's assistant conversation, so the next start is really fresh.
export const forgetDesign = productId => { localStorage.removeItem(STORAGE_KEY); if (productId) localStorage.removeItem(`mc-assistant-${productId}`); };

// Leaving the designer with unsaved changes: save (account / device), discard, or stay.
export const useLeaveGuard = ({ dirty, onSave, productId }) => {
  const [target, setTarget] = useState(null), [busy, setBusy] = useState(false), navigate = useNavigate();
  useEffect(() => {
    if (!dirty) return;
    const warn = e => { e.preventDefault(); e.returnValue = ''; };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [dirty]);
  const guard = (e, to) => { if (!dirty) return; e.preventDefault(); setTarget(to); };
  const go = () => { const to = target; setTarget(null); navigate(to); };
  const save = async () => { setBusy(true); try { await onSave(); go(); } finally { setBusy(false); } };
  const discard = () => { forgetDesign(productId); go(); };
  return { guard, dialog: target && <LeaveDialog busy={busy} onSave={save} onDiscard={discard} onStay={() => setTarget(null)} /> };
};

const LeaveDialog = ({ busy, onSave, onDiscard, onStay }) => {
  const account = useAccount();
  return <Dialog open onOpenChange={open => !open && !busy && onStay()}><DialogContent data-testid="leave-dialog">
    <DialogTitle>Design speichern?</DialogTitle>
    <DialogDescription>{account ? 'Gespeichert findest du es in deinem Konto unter „Entwürfe“ und beim nächsten Start unter „Letztes Design fortsetzen“.' : 'Gespeichert bleibt es auf diesem Gerät – beim nächsten Start kannst du es fortsetzen. Mit einem Kundenkonto ist es überall verfügbar.'}</DialogDescription>
    <div className="leave-actions">
      <Button onClick={onSave} disabled={busy} data-testid="leave-save">{busy && <Loader2 size={15} className="spin" />}Speichern</Button>
      <Button variant="outline" onClick={onDiscard} disabled={busy} data-testid="leave-discard">Verwerfen</Button>
      <Button variant="ghost" onClick={onStay} disabled={busy} data-testid="leave-stay">Weiter gestalten</Button>
    </div>
  </DialogContent></Dialog>;
};
